const widget = {
  'admin.widgets.hetmet': 'List widgets',
  'admin.widgets.breadcrumb.heading': 'Manage widgets',
  'admin.widgets.breadcrumb.parent': 'Widgets',
  'admin.widgets.btn.add': 'Add new widget',
  'admin.widget.modal.action.label.key': 'Key',
  'admin.widget.error-msg.key': 'Please enter key',
  'admin.widget.error-msg.title': 'Please enter title',
  'admin.widget.error-msg.duplicate': 'Key is duplicate',

  'admin.widget.modal.action.label.title': 'Title',
  'admin.widget.modal.action.label.icon': 'Icon',
  'admin.widget.modal.action.label.group': 'Group',
  'admin.widget.modal.action.label.group.name': 'Group name',
  'admin.widget.modal.action.label.group.slug': 'Group slug',
  'admin.widget.modal.action.title.create': 'Create widget',
  'admin.widget.modal.action.title.update': 'Update widget',
  'admin.widget.modal.action.title.details': 'Detail widget',
  'admin.widget.modal.action.label.description': 'Description',
  'admin.widget.modal.action.label.type': 'Type',
  'admin.widget.modal.action.setting.order': 'Setting',
  'admin.widget.modal.action.setting.option-count': 'options',
  'admin.widget.modal.action.setting.field-count': 'fields',
  'admin.widget.modal.action.setting.api.path': 'URL hoặc Pathname',
  'admin.widget.modal.action.setting.api.object': 'Khóa chứa danh sách',
  'admin.widget.modal.action.setting.api.value': 'Khóa làm giá trị',
  'admin.widget.modal.action.setting.api.title': 'Khóa làm tiêu đề',
  'admin.widget.modal.action.setting.config.key': 'Key',
  'admin.widget.modal.action.setting.config.value': 'Value',
  'admin.widget.modal.action.setting.config.title': 'Title',
  'admin.widget.modal.action.setting.close': 'Close',
  'admin.widget.modal.action.setting.update': 'Save',
  'admin.widget.modal.action.setting.selectbox.label': 'Selection list',
  'admin.widget.modal.action.setting.api.label': 'API setting',
  'admin.widget.modal.action.setting.list.label': 'List of data fields',
  'admin.widget.modal.action.setting.list.field': 'Data type',

  'admin.widget.content.section.label': 'Section',
  'admin.widget.content.section.add': 'Add section',

  'admin.widget.modal.delete.title': 'Confirmation of delete',
  'admin.widget.modal.delete.description': 'Are you sure to delete this widget',

  'admin.widget.noti.create-widget.success': 'Create widget successfully',
  'admin.widget.noti.create-widget.failure': 'Create widget failure',

  'admin.widget.noti.update-widget.success': 'Update widget successfully',
  'admin.widget.noti.update-widget.failure': 'Update widget failure',

  'admin.widget.noti.delete-widget.failure': 'Delete widget failure',
  'admin.widget.noti.delete-widget.success': 'Delete widget successfully',
};

export default {
  ...widget,
};
